import { render, staticRenderFns } from "./DocTypeBasedModel.vue?vue&type=template&id=109acef3&scoped=true&"
import script from "./DocTypeBasedModel.vue?vue&type=script&lang=js&"
export * from "./DocTypeBasedModel.vue?vue&type=script&lang=js&"
import style0 from "./DocTypeBasedModel.vue?vue&type=style&index=0&id=109acef3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "109acef3",
  null
  
)

export default component.exports